import { AnyObject } from '@mri/types';
import { Observable, of } from 'rxjs';

export function alwaysObservable(result: AnyObject): Observable<AnyObject>{
  if(!(result instanceof Observable)) return of(null);

  return result;
}
